/**
 *  基础API
 */
import http from '../assets/js/http'
// 通过token登录
export const loginByToken = (params) => { return http.request({ url: '/loginByToken', method: 'get', params: params }) }
// 登录
export const login = (params) => { return http.request({ url: '/login', method: 'post', params: params }) }
// 退出登录
export const loginOut = () => { return http.request({ url: '/loginOut', method: 'post' }) }
// 切换角色
export const changeRole = (params) => { return http.request({ url: '/changeRole', method: 'post', params: params }) }
// 连接测试
export const connectTest = () => { return http.request({ url: '/connectTest', method: 'get' }) }
// 参数吗值
export const csbDmms = (params) => { return http.request({ url: '/csbDmms', method: 'get', params: params }) }
